import { InjectionToken } from '@angular/core';

export interface MainComponentContext {
  getCurrentApplication(): any;
  getTermConfirmation(): any;
  onChangeApplication(application: any): void;
  onSelectApplication?(events: any, application: any): void;
  setApplicationArray(array: any): void;
  updateApplicationIndicator(): void;
}

export const MAIN_COMPONENT_CONTEXT = new InjectionToken<MainComponentContext>('MAIN_COMPONENT_CONTEXT');
